import React from 'react'
import { Dropdown } from 'react-bootstrap'
import styles from '../../UpdateSiteModal.module.css'

export const Toggle = ({ checked, onChange, id, ariaLabel, className = '', dataTestId = null }) => {
  return (
    <label htmlFor={id} className={`${styles.switch} ${className}`}>
      <input type="checkbox" checked={checked} onChange={onChange} id={id} aria-label={ariaLabel} />
      <span className={`${styles.slider} ${styles.sliderRound}`} data-testid={dataTestId}></span>
    </label>
  )
}

export const AccessOption = ({ iconClass, iconSrc, iconContent, title, description, control, learnMore }) => {
  return (
    <div className={styles.accessOptionWrapper}>
      <div className={styles.accessOption}>
        {(iconContent || iconSrc) && (
          <div className={`${styles.optionIcon} ${styles[iconClass]}`}>
            {iconSrc ? <img src={iconSrc} alt={title} height="24" width="24" className="op-6" /> : iconContent}
          </div>
        )}
        <div className={styles.optionDetails}>
          <div className={styles.optionTitle}>
            {title}{' '}
            {learnMore && (
              <a href={learnMore} target="_blank" className="ms-2 text-decoration-none font-small" rel="noreferrer">
                Learn more
              </a>
            )}
          </div>
          <div className={styles.optionDescription}>{description}</div>
        </div>
      </div>

      {control}
    </div>
  )
}

/**
 * Generic mode dropdown. Options may supply onSelect(value) → false to cancel the change
 * (e.g. upgrade gates, external setup flows).
 */
export const AccessModeDropdown = ({ value, onChange, options, checkFeatureAccess }) => {
  const selectedOption = options.find((option) => option.value === value)

  const handleSelect = (selectedValue) => {
    const option = options.find((item) => item.value === selectedValue)
    if (option?.onSelect && option.onSelect(selectedValue) === false) {
      return
    }
    if (checkFeatureAccess && !checkFeatureAccess(selectedValue)) {
      return
    }
    onChange(selectedValue)
  }

  return (
    <Dropdown className={styles.accessModeDropdown}>
      <Dropdown.Toggle variant="outline-light" id="dropdown-access-mode" className={styles.accessModeToggle}>
        <span className={styles.accessModeDropdownLabel}>{selectedOption?.label}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.accessModeMenu}>
        {options.map((option) => (
          <Dropdown.Item
            key={option.value}
            eventKey={option.value}
            active={value === option.value}
            onClick={() => handleSelect(option.value)}
            className={`dropdown-item ${styles.dropdownItem}`}
          >
            <div className={styles.dropdownItemContent}>
              <div>{option.label}</div>
              {option.description && <div className={styles.dropdownDescription}>{option.description}</div>}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export const LeadCaptureModeDropdown = ({ value, onChange, options, checkFeatureAccess }) => {
  const selectedOption = options.find((option) => option.value === value)

  const handleSelect = (selectedValue) => {
    if (checkFeatureAccess && !checkFeatureAccess(selectedValue)) {
      return
    }
    onChange(selectedValue)
  }

  return (
    <Dropdown className={styles.accessModeDropdown}>
      <Dropdown.Toggle variant="outline-light" id="dropdown-lead-capture-mode" className={styles.accessModeToggle}>
        <span className={styles.accessModeDropdownLabel}>{selectedOption?.label}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.accessModeMenu}>
        {options.map((option) => (
          <Dropdown.Item
            key={option.value}
            eventKey={option.value}
            active={value === option.value}
            onClick={() => handleSelect(option.value)}
            className={`dropdown-item ${styles.dropdownItem}`}
          >
            <div className={styles.dropdownItemContent}>
              <div>{option.label}</div>
              {option.description && <div className={styles.dropdownDescription}>{option.description}</div>}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
